import styled from "styled-components";

// Modal *chrome* (surface, header, close button, backdrop) is defined once in
// layout/scss/_modals.scss so it reaches every modal in the app, including the
// 56 files that render reactstrap's <Modal> directly. These helpers only add
// body and footer layout on top of it.

export const TwoButtonModalFooter = styled.div.attrs({ className: "modal-footer" })`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

export const FlexibleButtonModalFooter = styled.div.attrs({ className: "modal-footer" })`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

export const PathwayModalBody = styled.div.attrs({ className: "modal-body" })`
    display: grid;
    column-gap: var(--gap-l);
    row-gap: var(--gap-l);
`;
